import { PileDisplayProperties } from "../components/Board";
import { CardData } from "../components/Card";
import { GameModel, PileCardModel, PileModel } from "../interface/game";

export function pileCardModelToCardDisplayProperties(model: GameModel) {
    return (card: PileCardModel) => {
        const cardModel = model.getCardModel(card.id);
        return {
            id: cardModel.id,
            card: {
                faceUp: cardModel.faceUp,
                suit: cardModel.faceUp ? cardModel.suit : undefined,
                value: cardModel.faceUp ? cardModel.value : undefined
            } as CardData,
            shift: cardModel.shift,
            draggable: card.draggable,
        };
    }
}

export function pileIdToPileDisplayProperty(model: GameModel) {
    return (pileId: string): PileDisplayProperties => {
        const pileModel = model.getPiledModel(pileId);
        return {
            pileId: pileId,
            row: pileModel.row,
            col: pileModel.col,
            direction: pileModel.direction,
            clickable: pileModel.clickable
        }
    }
}

export function pileModelToPileDisplayPoperties(model: PileModel): PileDisplayProperties {
    return {
        pileId: model.id,
        col: model.col,
        row: model.row,
        direction: model.direction,
        clickable: model.clickable
    };
}